/* tslint:disable */
/* eslint-disable */
/**
 * Mercatus Portal
 * Mercatus Portal
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@gomercatus.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { Entitlement } from '../model';
// @ts-ignore
import { EntitlementUpdate } from '../model';
// @ts-ignore
import { LicenseType } from '../model';
/**
 * EntitlementApi - axios parameter creator
 * @export
 */
export const EntitlementApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Every permission the role admin offers for this role, and so every box of its permission grid. Group by target.feature for the grid\'s sections.
         * @summary The entitlements a role may be granted.
         * @param {number} [roleId] 
         * @param {LicenseType} [licenseType] As on GET /security/entitlement, including that it is currently ignored, and must be passed the same way for both: narrowing one list and not the other would show boxes that could never be ticked.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailableEntitlements: async (roleId?: number, licenseType?: LicenseType, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/security/entitlement/available`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (roleId !== undefined) {
                localVarQueryParameter['roleId'] = roleId;
            }

            if (licenseType !== undefined) {
                localVarQueryParameter['licenseType'] = licenseType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * The granted subset of what /security/entitlement/available offers for the same role, and so the checked boxes of the role admin\'s permission grid. Matched against that list by authority.
         * @summary The entitlements a role has been granted.
         * @param {number} [roleId] Omit for the entitlements of the organization rather than of one role.
         * @param {LicenseType} [licenseType] Intended to restrict the result to the entitlements that licence may hold, and passed as LITE for the built-in Lite role. NOT YET IMPLEMENTED: both read paths in EntitlementDataserviceImpl carry a \&quot;TODO compare License Type parameter to entitlements\&quot; and ignore the argument, so every value currently answers as ALL. The parameter is described because the legacy screen sent it and clients still should, but do not rely on the result being narrowed until that TODO is closed.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntitlements: async (roleId?: number, licenseType?: LicenseType, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/security/entitlement`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (roleId !== undefined) {
                localVarQueryParameter['roleId'] = roleId;
            }

            if (licenseType !== undefined) {
                localVarQueryParameter['licenseType'] = licenseType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * A cross-organization export of which roles hold which entitlements, offered from the role list. The body carries a UTF-8 BOM so that Excel recognises the encoding, and the filename comes back in Content-Disposition.
         * @summary Every role\'s entitlements, as a CSV.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntitlementsAsCsv: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/security/entitlement/csv`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * A full replacement rather than a delta: the body is every entitlement the role is to hold afterwards, and one omitted is one taken away. Returns the role\'s entitlements as they now stand.
         * @summary Replace the entitlements of a role.
         * @param {number} roleId 
         * @param {Array<EntitlementUpdate>} entitlementUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRoleEntitlements: async (roleId: number, entitlementUpdate: Array<EntitlementUpdate>, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'roleId' is not null or undefined
            assertParamExists('updateRoleEntitlements', 'roleId', roleId)
            // verify required parameter 'entitlementUpdate' is not null or undefined
            assertParamExists('updateRoleEntitlements', 'entitlementUpdate', entitlementUpdate)
            const localVarPath = `/security/entitlement/role/{roleId}`
                .replace(`{${"roleId"}}`, encodeURIComponent(String(roleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(entitlementUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EntitlementApi - functional programming interface
 * @export
 */
export const EntitlementApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EntitlementApiAxiosParamCreator(configuration)
    return {
        /**
         * Every permission the role admin offers for this role, and so every box of its permission grid. Group by target.feature for the grid\'s sections.
         * @summary The entitlements a role may be granted.
         * @param {number} [roleId] 
         * @param {LicenseType} [licenseType] As on GET /security/entitlement, including that it is currently ignored, and must be passed the same way for both: narrowing one list and not the other would show boxes that could never be ticked.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAvailableEntitlements(roleId?: number, licenseType?: LicenseType, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Entitlement>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAvailableEntitlements(roleId, licenseType, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * The granted subset of what /security/entitlement/available offers for the same role, and so the checked boxes of the role admin\'s permission grid. Matched against that list by authority.
         * @summary The entitlements a role has been granted.
         * @param {number} [roleId] Omit for the entitlements of the organization rather than of one role.
         * @param {LicenseType} [licenseType] Intended to restrict the result to the entitlements that licence may hold, and passed as LITE for the built-in Lite role. NOT YET IMPLEMENTED: both read paths in EntitlementDataserviceImpl carry a \&quot;TODO compare License Type parameter to entitlements\&quot; and ignore the argument, so every value currently answers as ALL. The parameter is described because the legacy screen sent it and clients still should, but do not rely on the result being narrowed until that TODO is closed.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEntitlements(roleId?: number, licenseType?: LicenseType, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Entitlement>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEntitlements(roleId, licenseType, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * A cross-organization export of which roles hold which entitlements, offered from the role list. The body carries a UTF-8 BOM so that Excel recognises the encoding, and the filename comes back in Content-Disposition.
         * @summary Every role\'s entitlements, as a CSV.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEntitlementsAsCsv(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEntitlementsAsCsv(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * A full replacement rather than a delta: the body is every entitlement the role is to hold afterwards, and one omitted is one taken away. Returns the role\'s entitlements as they now stand.
         * @summary Replace the entitlements of a role.
         * @param {number} roleId 
         * @param {Array<EntitlementUpdate>} entitlementUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateRoleEntitlements(roleId: number, entitlementUpdate: Array<EntitlementUpdate>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Entitlement>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateRoleEntitlements(roleId, entitlementUpdate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * EntitlementApi - factory interface
 * @export
 */
export const EntitlementApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EntitlementApiFp(configuration)
    return {
        /**
         * Every permission the role admin offers for this role, and so every box of its permission grid. Group by target.feature for the grid\'s sections.
         * @summary The entitlements a role may be granted.
         * @param {number} [roleId] 
         * @param {LicenseType} [licenseType] As on GET /security/entitlement, including that it is currently ignored, and must be passed the same way for both: narrowing one list and not the other would show boxes that could never be ticked.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailableEntitlements(roleId?: number, licenseType?: LicenseType, options?: any): AxiosPromise<Array<Entitlement>> {
            return localVarFp.getAvailableEntitlements(roleId, licenseType, options).then((request) => request(axios, basePath));
        },
        /**
         * The granted subset of what /security/entitlement/available offers for the same role, and so the checked boxes of the role admin\'s permission grid. Matched against that list by authority.
         * @summary The entitlements a role has been granted.
         * @param {number} [roleId] Omit for the entitlements of the organization rather than of one role.
         * @param {LicenseType} [licenseType] Intended to restrict the result to the entitlements that licence may hold, and passed as LITE for the built-in Lite role. NOT YET IMPLEMENTED: both read paths in EntitlementDataserviceImpl carry a \&quot;TODO compare License Type parameter to entitlements\&quot; and ignore the argument, so every value currently answers as ALL. The parameter is described because the legacy screen sent it and clients still should, but do not rely on the result being narrowed until that TODO is closed.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntitlements(roleId?: number, licenseType?: LicenseType, options?: any): AxiosPromise<Array<Entitlement>> {
            return localVarFp.getEntitlements(roleId, licenseType, options).then((request) => request(axios, basePath));
        },
        /**
         * A cross-organization export of which roles hold which entitlements, offered from the role list. The body carries a UTF-8 BOM so that Excel recognises the encoding, and the filename comes back in Content-Disposition.
         * @summary Every role\'s entitlements, as a CSV.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntitlementsAsCsv(options?: any): AxiosPromise<string> {
            return localVarFp.getEntitlementsAsCsv(options).then((request) => request(axios, basePath));
        },
        /**
         * A full replacement rather than a delta: the body is every entitlement the role is to hold afterwards, and one omitted is one taken away. Returns the role\'s entitlements as they now stand.
         * @summary Replace the entitlements of a role.
         * @param {number} roleId 
         * @param {Array<EntitlementUpdate>} entitlementUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRoleEntitlements(roleId: number, entitlementUpdate: Array<EntitlementUpdate>, options?: any): AxiosPromise<Array<Entitlement>> {
            return localVarFp.updateRoleEntitlements(roleId, entitlementUpdate, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EntitlementApi - object-oriented interface
 * @export
 * @class EntitlementApi
 * @extends {BaseAPI}
 */
export class EntitlementApi extends BaseAPI {
    /**
     * Every permission the role admin offers for this role, and so every box of its permission grid. Group by target.feature for the grid\'s sections.
     * @summary The entitlements a role may be granted.
     * @param {number} [roleId] 
     * @param {LicenseType} [licenseType] As on GET /security/entitlement, including that it is currently ignored, and must be passed the same way for both: narrowing one list and not the other would show boxes that could never be ticked.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitlementApi
     */
    public getAvailableEntitlements(roleId?: number, licenseType?: LicenseType, options?: any) {
        return EntitlementApiFp(this.configuration).getAvailableEntitlements(roleId, licenseType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * The granted subset of what /security/entitlement/available offers for the same role, and so the checked boxes of the role admin\'s permission grid. Matched against that list by authority.
     * @summary The entitlements a role has been granted.
     * @param {number} [roleId] Omit for the entitlements of the organization rather than of one role.
     * @param {LicenseType} [licenseType] Intended to restrict the result to the entitlements that licence may hold, and passed as LITE for the built-in Lite role. NOT YET IMPLEMENTED: both read paths in EntitlementDataserviceImpl carry a \&quot;TODO compare License Type parameter to entitlements\&quot; and ignore the argument, so every value currently answers as ALL. The parameter is described because the legacy screen sent it and clients still should, but do not rely on the result being narrowed until that TODO is closed.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitlementApi
     */
    public getEntitlements(roleId?: number, licenseType?: LicenseType, options?: any) {
        return EntitlementApiFp(this.configuration).getEntitlements(roleId, licenseType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * A cross-organization export of which roles hold which entitlements, offered from the role list. The body carries a UTF-8 BOM so that Excel recognises the encoding, and the filename comes back in Content-Disposition.
     * @summary Every role\'s entitlements, as a CSV.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitlementApi
     */
    public getEntitlementsAsCsv(options?: any) {
        return EntitlementApiFp(this.configuration).getEntitlementsAsCsv(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * A full replacement rather than a delta: the body is every entitlement the role is to hold afterwards, and one omitted is one taken away. Returns the role\'s entitlements as they now stand.
     * @summary Replace the entitlements of a role.
     * @param {number} roleId 
     * @param {Array<EntitlementUpdate>} entitlementUpdate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitlementApi
     */
    public updateRoleEntitlements(roleId: number, entitlementUpdate: Array<EntitlementUpdate>, options?: any) {
        return EntitlementApiFp(this.configuration).updateRoleEntitlements(roleId, entitlementUpdate, options).then((request) => request(this.axios, this.basePath));
    }
}
